import React from "react"
import {
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material"
import { getContent } from "components/Disclaimer/components/LanguageToggle"
import { credits_content } from "components/Disclaimer/content/content"

const MIT_appDependencies = [
  {
    lib: "@emotion/react",
    version: "11.11.1",
    copyright: "Copyright (c) Emotion team and other contributors",
  },
  {
    lib: "@emotion/styled",
    version: "11.11.0",
    copyright: "Copyright (c) Emotion team and other contributors",
  },
  {
    lib: "@mui/material",
    version: "5.14.5",
    copyright: "Copyright (c) 2014 Call-Em-All",
  },
  {
    lib: "@mui/icons-material",
    version: "5.14.3",
    copyright: "Copyright (c) 2014 Call-Em-All",
  },
  {
    lib: "@primer/octicons-react",
    version: "13.0.0",
    copyright: "Copyright (c) 2023 GitHub Inc.",
  },
  {
    lib: "gatsby",
    version: "5.12.0",
    copyright: "Copyright (c) 2015 Gatsbyjs",
  },
  {
    lib: "gatsby-plugin-image",
    version: "3.12.0",
    copyright: "Copyright (c) 2015 Gatsbyjs",
  },
  {
    lib: "gatsby-plugin-catch-links",
    version: "5.12.0",
    copyright: "Copyright (c) 2015 Gatsbyjs",
  },
  {
    lib: "gatsby-plugin-emotion",
    version: "8.12.0",
    copyright: "Copyright (c) 2015 Gatsbyjs",
  },
  {
    lib: "gatsby-plugin-sharp",
    version: "5.12.0",
    copyright: "Copyright (c) 2015 Gatsbyjs",
  },
  {
    lib: "gatsby-remark-images",
    version: "7.12.0",
    copyright: "Copyright (c) 2015 Gatsbyjs",
  },
  {
    lib: "gatsby-source-filesystem",
    version: "5.12.0",
    copyright: "Copyright (c) 2015 Gatsbyjs",
  },
  {
    lib: "gatsby-source-graphql",
    version: "5.12.0",
    copyright: "Copyright (c) 2015 Gatsbyjs",
  },
  {
    lib: "gatsby-transformer-remark",
    version: "6.12.0",
    copyright: "Copyright (c) 2015 Gatsbyjs",
  },
  {
    lib: "gatsby-transformer-sharp",
    version: "5.12.0",
    copyright: "Copyright (c) 2015 Gatsbyjs",
  },
  {
    lib: "gatsby-transformer-json",
    version: "6.12.0",
    copyright: "Copyright (c) 2015 Gatsbyjs",
  },
  {
    lib: "lodash",
    version: "4.17.21",
    copyright: "Copyright JS Foundation and other contributors",
  },
  {
    lib: "prop-types",
    version: "15.8.1",
    copyright: "Copyright (c) 2013-present, Facebook, Inc.",
  },
  {
    lib: "react",
    version: "18.2.0",
    copyright: "Copyright (c) Facebook, Inc. and its affiliates.",
  },
  {
    lib: "react-dom",
    version: "18.2.0",
    copyright: "Copyright (c) Facebook, Inc. and its affiliates.",
  },
  {
    lib: "react-helmet",
    version: "6.1.0",
    copyright: "Copyright (c) 2015 NFL",
  },
]

const BSD_custom_appDependencies = [
  {
    lib: "global-agent",
    version: "2.2.0",
    copyright: "Copyright (c) 2019, Gajus Kuizinas (http://gajus.com/)",
  },
]

const Credits = ({ currentLanguage }) => {
  const creditsStyle = {
    box: {
      marginTop: 20,
      marginBottom: 20,
    },
    package: {
      marginBottom: 10,
    },
  }

  const contentLanguage = getContent({
    language: currentLanguage,
    content: credits_content,
  })
  return (
    <div>
      <Typography variant={"h4"}>{contentLanguage.imgTitle}</Typography>
      <div css={creditsStyle.box}>
        <ul>
          <li>
            <Typography variant={"body1"}>
              Header image - Team: Nastco/iStockphoto via Getty Images
            </Typography>
          </li>
          <li>
            <Typography variant={"body1"}>
              Header image - Manifesto: blackred/iStockphoto via Getty Images
            </Typography>
          </li>
        </ul>
      </div>

      <Divider />

      <div css={creditsStyle.box} style={{ marginTop: 40 }}>
        <Typography variant={"h4"}>{contentLanguage.licenseTitle}</Typography>
        <p variant={"body1"}>
          {contentLanguage.licensePreamble1}{" "}
          <a href="mailto:foss@mercedes-benz.com">foss@mercedes-benz.com</a>
        </p>
        <p variant={"body1"}>{contentLanguage.licensePreamble2}</p>
      </div>

      <div css={creditsStyle.box}>
        <Typography style={{ textAlign: "center" }} variant={"h4"}>
          - MIT License -
        </Typography>
      </div>

      <TableContainer component={Paper}>
        <Table aria-label="dependencies table">
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Component name</b>
              </TableCell>
              <TableCell align={"center"}>
                <b>Version</b>
              </TableCell>
              <TableCell align={"right"}>
                <b>Copyright</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {MIT_appDependencies.map(deps => (
              <TableRow key={deps.lib}>
                <TableCell>{deps.lib}</TableCell>
                <TableCell align={"center"}>{deps.version}</TableCell>
                <TableCell align={"right"}>{deps.copyright}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div css={creditsStyle.box}>
        <p variant={"body1"}>
          Permission is hereby granted, free of charge, to any person obtaining
          a copy of this software and associated documentation files (the
          "Software"), to deal in the Software without restriction, including
          without limitation the rights to use, copy, modify, merge, publish,
          distribute, sublicense, and/or sell copies of the Software, and to
          permit persons to whom the Software is furnished to do so, subject to
          the following conditions:
        </p>
        <p variant={"body1"}>
          The above copyright notice and this permission notice shall be
          included in all copies or substantial portions of the Software.
        </p>
        <p variant={"body1"}>
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
          EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
          IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
          CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
          TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
          SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
        </p>
      </div>

      <div css={creditsStyle.box} style={{ marginTop: 40 }}>
        <Typography style={{ textAlign: "center" }} variant={"h4"}>
          - BSD-3-Clause - Gajus Kuizinas - License -
        </Typography>
      </div>

      <TableContainer component={Paper}>
        <Table aria-label="dependencies table">
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Component name</b>
              </TableCell>
              <TableCell align={"center"}>
                <b>Version</b>
              </TableCell>
              <TableCell align={"right"}>
                <b>Copyright</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {BSD_custom_appDependencies.map(deps => (
              <TableRow key={deps.lib}>
                <TableCell>{deps.lib}</TableCell>
                <TableCell align={"center"}>{deps.version}</TableCell>
                <TableCell align={"right"}>{deps.copyright}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div css={creditsStyle.box}>
        <p variant={"body1"}>
          Redistribution and use in source and binary forms, with or without
          modification, are permitted provided that the following conditions are
          met:
        </p>
        <div variant={"body1"}>
          <ul>
            <li>
              Redistributions of source code must retain the above copyright
              notice, this list of conditions and the following disclaimer.
            </li>
            <li>
              Redistributions in binary form must reproduce the above copyright
              notice, this list of conditions and the following disclaimer in
              the documentation and/or other materials provided with the
              distribution.
            </li>
            <li>
              Neither the name of the Gajus Kuizinas (http://gajus.com/) nor the
              names of its contributors may be used to endorse or promote
              products derived from this software without specific prior written
              permission.
            </li>
          </ul>
        </div>
        <p variant={"body1"}>
          THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
          "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
          LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
          A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ANUARY BE
          LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
          CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
          SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
          BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
          WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
          OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
          IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
        </p>
      </div>
    </div>
  )
}
export default Credits
